<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <FormStream
          :data="stream"
          :loading="isFormLoading"
          :disabled="isMutationLoading"
          :isNew="!id"
          @submit="onFormSubmit"
          @cancel="$router.push({ name: 'page-streams' })"
          @delete-stream="deleteDevice"
          :language="language"
          @language-update="language = $event"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmStreamRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import streamQuery from '@/services/gql/types/Stream/queries/stream.gql'
import createStreamMutation from '@/services/gql/types/Stream/mutations/createStream.gql'
import updateStreamMutation from '@/services/gql/types/Stream/mutations/updateStream.gql'
import deleteStreamMutation from '@/services/gql/types/Stream/mutations/deleteStream.gql'
import FormStream from './form'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { getListWithNewMainLanguage, setTranslation } from '@/utils/locales'
export default {
  name: 'PageStream',
  components: {
    ConfirmationDialog,
    FormStream
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать трансляцию' : 'Создать трансляцию'
    }
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      stream: {}
    }
  },
  computed: {
    isFormLoading () {
      return this.$apollo.queries.stream.loading
    },
    isMutationLoading () {
      return this.$async.createStream.$pending ||
        this.$async.updateStream.$pending
    }
  },
  methods: {
    onFormSubmit (formData) {
      if (!this.id) {
        this.createStream(formData)
      } else {
        this.updateStream(formData)
      }
    },
    async createStream (data) {
      try {
        delete data.translations
        await this.$async.createStream.$perform({ data })
        this.$successMsg('Трансляция добавлена')
        await this.$router.push({ name: 'page-streams' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при добавлении трансляции')
      }
    },
    async updateStream (data) {
      try {
        setTranslation(data, this.language)
        await this.$async.updateStream.$perform({
          id: parseInt(this.id),
          data
        }, { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) })
        this.$successMsg('Трансляция обновлена')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при обновлении трансляции')
      }
    },
    async deleteDevice () {
      try {
        await this.$refs.confirmStreamRemoving.open()
        await this.$async.deleteStream.$perform({ id: parseInt(this.id) })
        this.$successMsg('Трансляция удалена')
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении трансляции ${this.id}`)
      } finally {
        await this.$router.push({ name: 'page-streams' })
      }
    }
  },
  apollo: {
    stream: {
      fetchPolicy: 'network-only',
      query: streamQuery,
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: parseInt(this.id)
          }
        }
      },
      context () { return { headers: { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) } } },
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-streams' })
        } else {
          this.stream = res.data.stream
        }
      }
    }
  },
  async: {
    createStream (variables) {
      return this.$apollo.mutate({
        mutation: createStreamMutation,
        variables
      })
    },
    updateStream (variables, headers) {
      return this.$apollo.mutate({
        mutation: updateStreamMutation,
        variables,
        context: {
          headers
        }
      })
    },
    deleteStream (variables) {
      return this.$apollo.mutate({
        mutation: deleteStreamMutation,
        variables
      })
    }
  }
}
</script>
